// Module
var code = "<uib-tabset> <uib-tab ng-repeat=\"tab in componentController.getTabs() track by tab.id\" class=\"tab\" index=\"$index\" heading=\"{{tab.displayName}}\" ui-sref=\".{{tab.uiSrefFragment}}\" ui-sref-active=\"active\"> </uib-tab> </uib-tabset> ";
// Exports
export default code;